import Constants from '../utils/consts';
import SqlString from 'sqlstring';
var http = require('follow-redirects').https;
var qs = require('querystring');

export default async function ManageMeeting(username, token, event_id, id, date, hour, minutes, slots, company_id, companyBroker, investors, investorBrokers, deleteFlag, notes, notesRaw, rapresentativeNotPresent) {
    return new Promise(function (resolve, reject) {
        var options = {
        'method': 'POST',
        'hostname': Constants.ipAddress,
        'path': '/apis/manageMeeting.php',
        'headers': {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cookie': 'uid=e02675a1a7516909792f6850dffcd5fe'
        },
        'maxRedirects': 20
        };

        var req = http.request(options, function (res) {
        var chunks = [];

        res.on("data", function (chunk) {
            chunks.push(chunk);
        });

        res.on("end", function (chunk) {
            var body = Buffer.concat(chunks);
            console.log(body.toString());
            const resp = JSON.parse(body.toString());
            resolve(resp);
        });

        res.on("error", function (error) {
            console.error(error);
        });
        });

        var postData = qs.stringify({
            'uname': username,
            'token': token,
            'id' : id,
            'event_id' : event_id,
            'date' : date,
            'hour' : hour,
            'minutes' : minutes,
            'slots' : slots,
            'companyId' : company_id,
            'companyBroker' : companyBroker,
            'investors' : JSON.stringify({value: investors}),
            'investorBrokers': JSON.stringify({value: investorBrokers}),
            'deleteFlag' : deleteFlag,
            'notes' : notes,
            'notesRaw' : notesRaw,
            'rapresentativeNotPresent' : rapresentativeNotPresent,
        });

        console.log(postData);
        req.write(postData);

        req.end();

        
    });
}
